import React from 'react'
import TableCellMobile from './TableCellMobile'
import TableCellDesktop from './TableCellDesktop'

const TableCellEssai = ({
  item,
  label,
  device
}) => {
  const value = (item.essai === 1)
    ? 'Avec'
    : 'Sans'
  const object = {
    value: value,
    empty: (item.type === 'free_days')
  }
  return (device.mobile)
    ? <TableCellMobile
        label={label}
        {...object}
      />
    : <TableCellDesktop
        max={75}
        {...object}
      />
}

export default TableCellEssai
